import { createContext, useContext } from 'react';

import { TransponderType } from '@/services/transponders/types';

export type SelectedTranspondersType = TransponderType[];

export const SelectedTranspondersContext = createContext<SelectedTranspondersType>([]);

export const useSelectedTranspondersContext = () => useContext(SelectedTranspondersContext);
